import { Build as build, Version as version } from '@lib/constants/Version';

import {
    type AnalyticsEvent,
    type AnalyticsPayload,
    type DatalayerResetPayload,
    type IdentifyPayload,
    toEventPayload
} from './google';
import Sentry from './sentry';

const buildInfo = async () => {
    return {
        build,
        version,
        platform: 'web',
        tracking_allowed: true
    };
};

type DataLayerPayload = AnalyticsPayload<AnalyticsEvent> | DatalayerResetPayload | IdentifyPayload;

declare global {
    interface Window {
        dataLayer?: {
            push: (payload: DataLayerPayload) => void;
        };
    }
}

export async function identify(userId: string, traits: Record<string, string> = {}) {
    window.dataLayer?.push({
        user_id: parseInt(userId, 10)
    });
}

export async function track(name: string, properties: Record<string, unknown> = {}) {
    const build = await buildInfo();

    const newProps = { ...properties, ...build };

    Sentry.addBreadcrumb({
        category: 'Event',
        message: name,
        data: newProps
    });
}

// screenloaded calls page instead of screen
export async function screenLoaded(
    category: string,
    name: string,
    properties: Record<string, unknown> = {}
) {
    const build = await buildInfo();
    const newProps = { ...properties, ...build };

    Sentry.addBreadcrumb({
        category: 'Page Loaded',
        message: name,
        data: newProps
    });
}

export const push = (event: AnalyticsEvent) => {
    // see: https://developers.google.com/analytics/devguides/collection/ua/gtm/enhanced-ecommerce
    // we are required to push a null between each event to keep the events from merging.
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push(toEventPayload(event));
};
